import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdOauthMcpSettingsMcpEnabledCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/oauth_mcp_settings",
];
